import getProductLineLetter from '../utils/api/getProductLineLetter';
import { ACURA_SITE_NAME, API_MODES, HONDA_SITE_NAME, PSP_SITE_NAME } from '../utils/constants';
export const DEFAULT_CLIENT_REQUEST_ID = '12345-67890-12345';
/**
 * gets the apiPath for trim paymants based on the appName and VehicleType.
 *
 * @param {string} appName - The siteName.
 * @param {string} pageState - The pageState from sitecore context.
 * @param {string} vehicleType - The vehicleType for the TrimPackages.
 *  @returns {string} - Constructed apiPath for the request.
 */
export const getTrimPaymentApiPath = (appName, pageState, vehicleType = '', fetchMultiple) => {
    const productLineLetter = getProductLineLetter.get(appName);
    const financialPathSegment = 'financials-worksheets';
    const endpoint = fetchMultiple ? 'multi-vehicle-payment' : 'payment';
    let apiPath;
    switch (appName) {
        case PSP_SITE_NAME:
            apiPath = `${financialPathSegment}/${productLineLetter[vehicleType]}/${API_MODES[pageState]}/website/mcpe-payment-calculator?AcceptLanguage=en`;
            break;
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
        default:
            apiPath = `${financialPathSegment}/${productLineLetter}/${API_MODES[pageState]}/website/calculator/${endpoint}`;
            break;
    }
    return apiPath;
};
export const getTrimPaymentRequestObject = ({ appName, defaultProvince, downPaymentAmount, incentiveOfferIds, includeFees, leaseAdditionalAnnualKm, leaseAnnualKmAllowance, loyaltyOfferKey, overriddenIsSellingProvince, payload, paymentFrequency, paymentMethod, provinceCode, termAndRate, tradeInOwingAmount, tradeInValueAmount, warrantyAmount, }) => {
    const { trimKey, modelKey, modelYear, exteriorColorKey, interiorColorKey, transmissionKey, accessories, protections, protectionAddOns, } = payload !== null && payload !== void 0 ? payload : {};
    const clientRequestId = DEFAULT_CLIENT_REQUEST_ID;
    const ownerPrograms = protections === null || protections === void 0 ? void 0 : protections.map(key => ({
        key,
        // FIXME: I do not like having to do this,
        // but this is to temporarily ensure that PSP is not touched for a critical BAP fix
        term: appName === PSP_SITE_NAME ? null : termAndRate,
        isAddonIncluded: protectionAddOns.some(value => value === key),
    }));
    const commonProperties = {
        accessories,
        exteriorColorKey,
        modelKey,
        modelYear,
        trimKey,
        transmissionKey,
        warrantyAmount,
    };
    switch (appName) {
        case PSP_SITE_NAME:
            return {
                financeDownPayment: 0,
                financeTerm: 60,
                includeFees,
                leaseAdditionalAnnualKm: 0,
                leaseAnnualKmAllowance: 0,
                leaseDownPayment: 0,
                leaseTerm: 0,
                locale: 'en',
                loyaltyOfferKey,
                offerKey: null,
                overriddenIsSellingProvince,
                ownerPrograms,
                paymentType: paymentFrequency,
                province: provinceCode || defaultProvince,
                useHighestTerm: true,
                warrantyKey: '',
                ...commonProperties,
            };
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
        default:
            return {
                interiorColorKey,
                provinceKey: provinceCode || defaultProvince,
                paymentOptions: [
                    {
                        clientRequestId,
                        downPaymentAmount,
                        incentiveOfferIds,
                        includeFees,
                        leaseAdditionalAnnualKm,
                        leaseAnnualKmAllowance,
                        loyaltyOfferKey,
                        overriddenIsSellingProvince,
                        ownerPrograms,
                        paymentFrequency,
                        paymentMethod,
                        preferredPaymentAmount: 0,
                        term: termAndRate,
                        tradeInOwingAmount,
                        tradeInValueAmount,
                    },
                ],
                ...commonProperties,
            };
    }
};
/**
 * gets the required response property for payment api based on the appName.
 *
 * @param {string} appName - The siteName.
 * @param {Object} response - The response data from api request.
 * @returns {Object} - The mapped request response.
 */
// TODO: response is a raw API response, replace with a typed object from RTK query transformResponse
export const getTrimPaymentResponseObject = (appName, response) => {
    var _a, _b;
    let responseObject = {
        msrp: undefined,
        cashPurchase: undefined,
    };
    switch (appName) {
        case PSP_SITE_NAME:
            responseObject = (_a = response === null || response === void 0 ? void 0 : response.finance) === null || _a === void 0 ? void 0 : _a.weekly;
            responseObject.msrp = response.msrp;
            responseObject.cashPurchase = response.cashPurchase;
            break;
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
        default:
            responseObject = (_b = response === null || response === void 0 ? void 0 : response.paymentOptions) === null || _b === void 0 ? void 0 : _b[0];
            break;
    }
    return responseObject;
};
/**
 * gets the apiPath for build and price summary based on the appName
 *
 * @param {string} appName - The siteName.
 * @param {string} pageState - The pageState from sitecore context.
 *  @returns {string} - Constructed apiPath for the request.
 */
export const getBuildPriceSummaryPath = (appName, pageState) => {
    const productLineLetter = getProductLineLetter.get(appName);
    const financialPathSegment = 'financials-worksheets';
    const buildandpricePathSegment = 'buildandprice/calculator/summary';
    let apiPath;
    switch (appName) {
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
        default:
            apiPath = `${financialPathSegment}/${productLineLetter}/${API_MODES[pageState]}/${buildandpricePathSegment}`;
            break;
    }
    return apiPath;
};
